<template>
  <section id="rates">
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="rates-header">
            <h2 class="rates-header_title">{{ $t('rates.title') }}</h2>
            <div class="rates-header_date">{{date}}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" lg="4">
          <div class="rates rates__btc box">
            <h3 align="center">BTC <img src="@/assets/btc@2x.png" alt /></h3>
            <p>{{ $t('rates.buy') }}</p>
            <div class="rates_buy">
              <RateLabel name="USD" :rate="(coinsRates.BTC.USD + (coinsRates.BTC.USD * commissionRates.BTC.buy)).toFixed(3)"></RateLabel>
            </div>
            <p>{{ $t('rates.sell') }}</p>
            <div class="rates_sell">
              <RateLabel name="USD" :rate="(coinsRates.BTC.USD + (coinsRates.BTC.USD * commissionRates.BTC.sell)).toFixed(3)"></RateLabel>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <div class="rates rates__btc box">
            <h3 align="center">ETH <img src="@/assets/eth@2x.png" alt /></h3>
            <p>{{ $t('rates.buy') }}</p>
            <div class="rates_buy">
              <RateLabel name="USD" :rate="(coinsRates.ETH.USD + (coinsRates.ETH.USD * commissionRates.USD.buy)).toFixed(3)"></RateLabel>
            </div>
            <p>{{ $t('rates.sell') }}</p>
            <div class="rates_sell">
              <RateLabel name="USD" :rate="(coinsRates.ETH.USD + (coinsRates.ETH.USD * commissionRates.ETH.sell)).toFixed(3)"></RateLabel>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <div class="rates rates__btc box">
            <h3 align="center">USDT <img src="@/assets/usdt@2x.png" alt /></h3>
            <p>{{ $t('rates.buy') }}</p>
            <div class="rates_buy">
              <RateLabel name="USD" :rate="(1 * 1.000 + (1 * 1.000 * commissionRates.USDT.buy)).toFixed(3)"></RateLabel>
            </div>
            <p>{{ $t('rates.sell') }}</p>
            <div class="rates_sell">
              <RateLabel name="USD" :rate="(1 * 1.000 + (1 * 1.000 * commissionRates.USDT.sell)).toFixed(3)"></RateLabel>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <div align="center" class="info">
            <div class="info">{{ $t('rates.note') }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" style="padding-top: 20px">
          <a
            class="btn btn__succes"
            href="https://telegram.me/MoneyCashBit"
            target="_blank"
          >{{ $t('common.telegramCta') }}</a>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
'use strict';
import RateLabel from "@/components/RateLabel";

export default {
  data: () => ({
    date: ""
}),
  computed: {
    coinsRates() {
      return this.$store.getters.coinsRates;
    },
    fiatRates() {
      return this.$store.getters.fiatRates;
    },
    commissionRates() {
      return this.$store.getters.commissionRates;
    }
  },
  methods: {
    getNow: function() {
                    const today = new Date();
                    const date = today.getDate()+'.'+(today.getMonth()+1)+'.'+today.getFullYear();
                    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    const dateTime = date +' '+ time;
                    this.date = dateTime;
                }
  },
  created: function () {
    this.$store.dispatch("getFiatRates");
    this.$store.dispatch("getCoinsRates");
    this.$store.dispatch("getСommissionRates");
    setInterval(this.getNow, 1000);
  },
  components: {
    RateLabel
  }
};
</script>

<style lang="sass">
.rates
  &_buy, &_sell
    margin-bottom: 1rem

.rates-header
  display: flex
  justify-content: center
  align-items: center
  &_title, &_date
    margin: 0 10px
  &_date
    padding: 10px
    font-family: 'Montserrat', sans-serif
    font-size: 1.5rem
    font-weight: bold
    color: #fffffe
    background-color: #16161a
    border-radius: 5px
    box-shadow: 0px 0px 10px rgba(22, 22, 26, .5)

@media screen and (max-width: 576px)
  .rates-header
    flex-wrap: wrap
    &_title, &_date
      width: 100%
      text-align: center
    &_title
      margin-bottom: 1rem

.calculator
  &_header
    text-align: center
  &_sell, &_buy
    width: 100%
    margin-top: 10%
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
  .btn__succes
    margin-top: 1rem

@media screen and (max-width: 576px)
  .calculator
    .img
      width: 25%
      transform: rotate(90deg)
</style>